import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  updateExerciseEntryNote
} from '../../../redux/slices/admin/dragSlice';

const NotesModal = ({ isOpen, onClose, currentNote, selectedExercise, refresh}) => {
  const dispatch = useDispatch();
  const [note, setNote] = useState('');

  useEffect(() => {
      setNote(currentNote);
  }, [currentNote]);

  const handleSearch = (event) => {
    const term = event.target.value;
    setNote(term);
  };

  const handleSave = (e) => {
    e.preventDefault();
    var p = { exercise_id:selectedExercise, notes:note};  
    dispatch(updateExerciseEntryNote(p));
    onClose();

  };

  return isOpen ? (
    <div
      className="modal fade show replace-exercise-modal"
      style={{ display: "block" }}
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Update Note</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSave}>
              <div className="w-100 mt-4">
                
                <input
                  type="text"
                  id="search"
                  placeholder="Type note here"
                  value={note}
                  onChange={handleSearch}
                  className="form-control"
                />
              </div>
              <div className="form-group mb-0 mt-4">
                <button
                  type="submit"
                  className="btn btn-create w-100"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  ) : null;
};

export default NotesModal;